import { useCourseContext } from '../../../../../course/Context';
import { useClassContext } from '../../../../Context';
import { useAttendancePageContext } from '../../Context';
import { AttendancePageScreens } from '../../types';

const useAttendanceAction = () => {
  const { setCourse } = useCourseContext();
  const { setClass } = useClassContext();
  const { currentScreen, setCurrentScreen } = useAttendancePageContext();

  const handleClickReuseAttendance = () => {
    setCourse(null);
    setClass(null);
    setCurrentScreen(AttendancePageScreens.RECORD_ATTENDANCE);
  };
  return { currentScreen, handleClickReuseAttendance };
};

export default useAttendanceAction;
